import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { toast } from "react-toastify";
import API from "../Services/Report";
import * as XLSX from "xlsx";

const Reversel = forwardRef(
  ({ filters, selectedCenter, resetTrigger, applyTrigger }, ref) => {
    const [reverseCoins, setReverseCoins] = useState([]);
    const [reverselCount, setReverselCount] = useState(0);

    const recordsPerPage = 10;
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];
    const pastDate = new Date();
    pastDate.setDate(pastDate.getDate() - 90);
    const formattedPastDate = pastDate.toISOString().split("T")[0];



    const [columnTotals, setColumnTotals] = useState({
      TotalReversedSkyCoin: 0
    });


    const downloadCSV = async () => {
      if (reverselCount <= 0) {
        toast.info("No data available for download");
        return;
      }
      try {
        const centerList = Array.isArray(selectedCenter)
          ? selectedCenter.join(",")
          : selectedCenter;

        const payloadData = {
          start_date: filters.startDate || formattedPastDate,
          end_date: filters.endDate || formattedToday,
          location_id:
            centerList && centerList.length > 0 ? centerList : null,
          limit: reverselCount,
        };

        const response = await API.getReverselPointReport(payloadData);



        const result = response.data.result;

        const worksheet = XLSX.utils.json_to_sheet(result);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "ReverselReport");

        XLSX.writeFile(workbook, "ReverselReport.xlsx");

      } catch (error) {
        console.error("Excel Download Failed:", error);
        toast.error("Failed to download report");
      }
    };

    useImperativeHandle(ref, () => ({
      downloadCSV,
    }));

    const getReverselReport = async (page = 1) => {
      try {
        const centerlist = Array.isArray(selectedCenter)
          ? selectedCenter.join(",")
          : selectedCenter;

        const payloadData = {
          start_date: filters.startDate || formattedPastDate,
          end_date: filters.endDate || formattedToday,
          location_id:
            centerlist && centerlist.length > 0 ? centerlist : null,
          page_number: page,
          limit: recordsPerPage,
        };

        const response = await API.getReverselPointReport(payloadData);

        if (response?.status === 200 && Array.isArray(response?.data?.result)) {
          const result = response.data.result;

          // console.log('reversa',response?.data?.result?.length);

          const totalCount = response?.data?.total_count || response?.data?.result?.length;
          setReverseCoins(result);
          setReverselCount(totalCount);
          setTotalPages(Math.ceil(totalCount / recordsPerPage));
          setCurrentPage(page);
          calculateTotals(result);
        } else {
          setReverseCoins([]);
          setTotalPages(1);
          toast.error(response?.data?.message || "No data found");
        }
      } catch (error) {
        toast.error("Something went wrong while fetching reversel report");
        setReverseCoins([]);
        setTotalPages(1);
      }
    };

    const getPageNumbers = () => {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    };

    const handlePageChange = (page) => {
      if (page < 1 || page > totalPages) return;
      getReverselReport(page);
    };

    useEffect(() => {
      if (applyTrigger === 0 && resetTrigger === 0) return;
      getReverselReport(1);
    }, [applyTrigger, resetTrigger]);

    const calculateTotals = (data) => {
      let totalSum = 0;

      data.forEach((item) => {
        totalSum += Number(item.reversed_sky_coin) || 0;
      });
      setColumnTotals({
        totalReversedSkyCoin: totalSum,
      });
    };

    return (
      <div>
        <div className="modern-table-container">
          <div className="modern-table-header">
            <div className="modern-table-title">
              Reversel Report ({reverselCount})
            </div>
          </div>

          <div className="p-4 text-center">
            <div className="modern-table-container">
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-bordered text-center">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Center</th>
                        <th>Employee Name</th>
                        <th>Product name</th>
                        <th>Card No</th>
                        <th>Reversed Sky Coins</th>
                        <th>Created Date</th>
                      </tr>
                    </thead>

                    <tbody>
                      {reverseCoins.length > 0 ? (
                        reverseCoins.map((item, index) => (
                          <tr key={index}>
                            <td>
                              {(currentPage - 1) * recordsPerPage + index + 1}
                            </td>
                            <td>{item?.center || "N/A"}</td>
                            <td>{item?.employee_name || "N/A"}</td>
                            <td>{item?.product_name || "N/A"}</td>
                            <td>{item?.card_number || "N/A"}</td>
                            <td>{item?.reversed_sky_coin || "N/A"}</td>
                            <td>{item?.createdAt || "N/A"}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7">No data available</td>
                        </tr>
                      )}
                    </tbody>
                    {/* <tfoot>
                      <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th>Total Reversed Sky Coins</th>
                        <th>{columnTotals?.totalReversedSkyCoin?.toFixed(2) || "0.00"}</th>
                      </tr>
                    </tfoot> */}
                  </table>

                  {/* PAGINATION */}
                  <nav>
                    <ul className="pagination justify-content-center mt-4">
                      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>

                      {getPageNumbers().map((page, i) => (
                        <li
                          key={i}
                          className={`page-item ${page === currentPage ? "active" : ""}`}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(page)}
                          >
                            {page}
                          </button>
                        </li>
                      ))}

                      <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
);

export default Reversel;
